import { FC, useContext } from 'react';
import { CbButton } from 'ui/components/Buttons/CbButton';
import { ICON_BY_NAME } from '../Icons/Icon';
import { TableContext, TableDrawerName } from './';
import styles from './CbTable.module.css';
export const AllFilters: FC = () => {
  const {
    filterInfo,
    setDrawer
  } = useContext(TableContext);
  if (filterInfo.length === 0) return null;
  const onClick = () => setDrawer({
    name: TableDrawerName.AllFilters
  });
  return <CbButton onClick={onClick} size="sm" variant="outline" data-sentry-element="CbButton" data-sentry-component="AllFilters" data-sentry-source-file="AllFilters.tsx">
      <span className={styles.buttonContent}>
        <ICON_BY_NAME.filteroutline data-sentry-element="unknown" data-sentry-source-file="AllFilters.tsx" />
        All filters
      </span>
    </CbButton>;
};